export default __webpack_public_path__ + "static/capsule-ui-circle-0d405124944064e5f1df8320689be4b2.svg";